import styled from 'styled-components'
import { Alert } from 'antd'

const ContainerFormButtons = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
`

const WrapChangeBlock = styled.div`
  display: flex;
  flex-wrap: nowrap;
  > button {
    padding: 0 3px;
  }
`

const WrapContent = styled.div`
  margin: 8px 16px 24px 16px;
`

const WrapAlert = styled(Alert)`
  margin-bottom: 8px;
`

export { ContainerFormButtons, WrapChangeBlock, WrapContent, WrapAlert }
